
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by KDS"
      links={[
        {
          key: 'KDS',
          title: 'KDS',
          href: 'https://club.kdslife.com',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
